module.exports = __webpack_public_path__ + "img/exit.62d5a3e8.png";